import { render, staticRenderFns } from "./award.vue?vue&type=template&id=3b86ae80&"
import script from "./award.vue?vue&type=script&lang=ts&"
export * from "./award.vue?vue&type=script&lang=ts&"
import style0 from "./award.vue?vue&type=style&index=0&module=true&lang=stylus&"
import style1 from "./award.vue?vue&type=style&index=1&lang=stylus&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports